module.exports = __webpack_public_path__ + "img/2.abd4066e.png";